module.exports = __webpack_public_path__ + "img/7da5faf.jpg";